module.exports = __webpack_public_path__ + "static/media/ray.0e5c65a2.png";